import { render, staticRenderFns } from "./media-sharing.vue?vue&type=template&id=9db7aa8c&scoped=true"
import script from "./media-sharing.vue?vue&type=script&lang=js"
export * from "./media-sharing.vue?vue&type=script&lang=js"
import style0 from "./media-sharing.vue?vue&type=style&index=0&id=9db7aa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db7aa8c",
  null
  
)

export default component.exports